<template>
  <button ref="button" :class="getClass()" :disabled="disabled" @click="action">
    <span v-if="loading" class="mx-2"><i class="fa fa-spin fa-sync"></i></span>
    <span
      v-if="!loading || size !== 'icon'"
      class="flex items-center justify-center h-full w-full relative"
      ><slot></slot
    ></span>
  </button>
</template>

<style>
button.icon-button {
  padding: 6px;
}
button.icon-button svg {
  max-height: 100%;
  max-width: 100%;
}
</style>

<script>
import mixins from '../mixins';

const btnBaseClass = 'min-w-32 h-10 px-4 py-2 font-semibold mr-2 rounded-lg shadow-lg inline-flex items-center justify-center';
const variantClassMap = {
  shadow: `${btnBaseClass} bg-white text-grey-500`,
  shadowPrimary: `${btnBaseClass} bg-pink hover:bg-pink-dark text-white`,
  shadowDark: `${btnBaseClass} bg-grey-700 hover:bg-grey-800 text-grey-500`
};

export default {
  name: 'GdButton',
  mixins: [mixins],
  props: {
    variant: String,
    groupPosition: String,
    primary: Boolean,
    disabled: Boolean,
    size: String,
    dark: Boolean,
    border: Boolean,
    transparent: Boolean,
    stopEvent: Boolean,
    loading: Boolean,
    bluePrimary: Boolean,
    onHoverDark: Boolean,
  },
  methods: {
    getClass() {
      if (this.variant) return this.hasState('disabled') ? `${variantClassMap[this.variant]} cursor-not-allowed` : variantClassMap[this.variant];
      let borderRadius = 'rounded-lg';
      let borderClass = 'border border-solid';
      let bgClass = 'bg-white';
      let textColor = 'text-pink-dark focus:text-black';
      let borderColor = '';
      let shadowClass = 'hover:shadow-lg focus:shadow-lg';
      let sizeClass = 'w-20';
      let heightSize = 'h-8';
      const heading = 'heading-sm';
      let extras = '';

      if (this.groupPosition === 'middle') {
        borderRadius = '';
        borderClass += ' border-l-0';
      } else if (this.groupPosition === 'left') {
        borderRadius = 'rounded-l-lg';
      } else if (this.groupPosition === 'right') {
        borderRadius = 'rounded-r-lg';
        borderClass += ' border-l-0';
      } else {
        borderColor += ' focus:border-black';
      }

      if (this.hasState('disabled')) {
        if (this.hasState('primary')) {
          bgClass = 'bg-grey-600';
          borderColor = 'border-grey-600';
          shadowClass = '';
          textColor = 'text-white';
        } else if (this.hasState('dark')) {
          bgClass = '';
          textColor = 'text-grey-500';
          borderColor = 'border-grey-700';
          shadowClass = '';
        } else {
          textColor = 'text-grey-500';
          borderColor = 'border-grey-300';
          shadowClass = '';
        }
        extras += ' cursor-not-allowed';
      } else if (this.hasState('primary')) {
          bgClass = 'bg-pink hover:bg-pink-dark focus:bg-black';
          textColor = 'text-white';
          borderColor = 'border-pink hover:border-pink-dark focus:border-black';
        } else if (this.hasState('bluePrimary')) {
          bgClass = 'bg-blue-dark hover:bg-blue focus:bg-black';
          textColor = 'text-white';
          borderClass = '';
        } else if (this.hasState('transparent')) {
          bgClass = 'bg-transparent hover:bg-pink focus:bg-pink';
          textColor = 'text-white';
          borderColor = 'border-white';
        } else if (this.hasState('onHoverDark')) {
          bgClass = 'bg-white focus:bg-transparent';
          textColor = 'text-pink-dark focus:text-white';
          borderColor = 'border-pink-dark focus:border-white';
        } else if (this.hasState('dark')) {
          bgClass = 'hover:bg-grey-700';
          textColor = 'text-grey-500';
          borderColor = 'border-grey-700';
        }

      if (this.size === 'icon') sizeClass = 'w-8 icon-button';
      if (this.size === 'large') sizeClass = 'w-32';
      if (this.size === 'auto') sizeClass = 'w-auto px-2';
      if (this.size === 'expand') sizeClass = 'flex flex-grow';
      if (this.size === 'x-small') sizeClass = 'w-4';
      if (this.size === 'medium') {
        sizeClass = 'min-w-32';
        heightSize = 'h-10';
      }

      return `flex items-center ${sizeClass} ${heightSize} ${heading} focus:outline-none shadow ${shadowClass} ${borderRadius} ${bgClass} ${textColor} ${borderColor} ${borderClass} ${extras}`;
    },
    action(e) {
      if (this.stopEvent) {
        e.stopPropagation();
      }
      this.$emit('click');
      setTimeout(() => {
        if (this.$refs.button) this.$refs.button.blur();
      }, 500);
    },
  },
};
</script>
